/** @jsx jsx */
import { jsx } from 'theme-ui';
import { MenuButton } from './MenuButton';
import { faBars, faChevronLeft, faChevronUp, } from '@fortawesome/pro-light-svg-icons';
import { useHasSideMenu } from '../hooks/menuHooks';
export var MenuToggleButton = function (_a) {
    var onOpenChange = _a.onOpenChange, open = _a.open;
    var menuAtSide = useHasSideMenu();
    return (jsx(MenuButton, { onClick: onOpenChange &&
            (function () {
                onOpenChange(!open);
            }), icon: !open ? faBars : menuAtSide ? faChevronLeft : faChevronUp, iconTitle: "Toggle menu" }));
};
//# sourceMappingURL=MenuToggleButton.js.map